/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
/**
 * 
 * @export
 * @interface Favorite
 */
export interface Favorite {
    /**
     * 
     * @type {number}
     * @memberof Favorite
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Favorite
     */
    contentfulType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Favorite
     */
    contentfulId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Favorite
     */
    userId?: number;
    /**
     * 
     * @type {Date}
     * @memberof Favorite
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Favorite
     */
    modified?: Date | null;
    /**
     * 
     * @type {User}
     * @memberof Favorite
     */
    user?: User;
}

/**
 * Check if a given object implements the Favorite interface.
 */
export function instanceOfFavorite(value: object): value is Favorite {
    return true;
}

export function FavoriteFromJSON(json: any): Favorite {
    return FavoriteFromJSONTyped(json, false);
}

export function FavoriteFromJSONTyped(json: any, ignoreDiscriminator: boolean): Favorite {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'contentfulType': json['contentfulType'] == null ? undefined : json['contentfulType'],
        'contentfulId': json['contentfulId'] == null ? undefined : json['contentfulId'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'modified': json['modified'] == null ? undefined : (new Date(json['modified'])),
        'user': json['user'] == null ? undefined : (require('./User') as typeof import('./User')).UserFromJSON(json['user']),
    };
}

export function FavoriteToJSON(json: any): Favorite {
    return FavoriteToJSONTyped(json, false);
}

export function FavoriteToJSONTyped(value?: Favorite | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'contentfulType': value['contentfulType'],
        'contentfulId': value['contentfulId'],
        'userId': value['userId'],
        'created': value['created'] == null ? value['created'] : value['created'].toISOString(),
        'modified': value['modified'] == null ? value['modified'] : value['modified'].toISOString(),
        'user': (require('./User') as typeof import('./User')).UserToJSON(value['user']),
    };
}

